const isLoggedIn = state => !!state.token
const authStatus = state => state.status;
const username = state => state.username;

export default {
    isLoggedIn,
    authStatus,
    username
}
